<form id="form" [formGroup]="Form" autocomplete="off" (keyup.enter)="emit_submit()">
    <h2>Wijzig je wachtwoord.</h2>
    <app-input-control [htmlAutocomplete]="'current-password'"
        [autofocus]="true"
        [control]="FormControls.currentPassword"
        [label]="'huidig wachtwoord'"
        [lockOnLoad]="true"
        [placeholder]="'vul je huidige wachtwoord in'"
        [showError]="showErrors || Form.touched"
        [tabIndex]="'0'"
        [type]="'password'" />
    <app-input-control [htmlAutocomplete]="'new-password'"
        [control]="FormControls.newPassword"
        [label]="'nieuw wachtwoord'"
        [lockOnLoad]="true"
        [placeholder]="'minimaal 10 tekens, met een cijfer'"
        [showError]="showErrors || Form.touched"
        [tabIndex]="'0'"
        [type]="'password'" />
    <app-input-control [htmlAutocomplete]="'new-password'"
        [control]="FormControls.newPasswordRepeat"
        [label]="'nieuw wachtwoord (herhaal)'"
        [lockOnLoad]="true"
        [placeholder]="'herhaal je nieuwe wachtwoord'"
        [showError]="showErrors || Form.touched"
        [tabIndex]="'0'"
        [type]="'password'" />
    @if ((showErrors || Form.touched) && FormControls.newPassword.errors?.['minlength']) {
        <p class="form-error">Wachtwoord moet minimaal 10 tekens bevatten.</p>
    }
    @if ((showErrors || Form.touched) && FormControls.newPassword.errors?.['pattern']) {
        <p class="form-error">Wachtwoord moet minimaal 1 cijfer bevatten.</p>
    }
    @if ((showErrors || Form.touched) && Form.errors?.['passwordMismatch']) {
        <p class="form-error">De wachtwoorden komen niet overeen.</p>
    }
</form>
